export const MAX_NAME_LENGTH = 14;

/** English letters/digits, plus underscore and hyphen. NO spaces (new rule). */
export const NAME_RE = /^[A-Za-z0-9_-]+$/;

/** Legacy pattern that still allows spaces — used for names already stored. */
const STORED_NAME_RE = /^[A-Za-z0-9 _-]+$/;

/** The one player grandfathered in with a space in their name (the owner). */
export const OWNER_NAME = "Daniel Guzev";

export function sanitizeName(raw: string): string {
  return raw.replace(/\s+/g, " ").trim().slice(0, MAX_NAME_LENGTH);
}

/** True if `name` is acceptable as a NEW name: space-free (owner excepted). */
export function isValidName(name: string): boolean {
  if (!name) return false;
  if (name.length > MAX_NAME_LENGTH) return false;
  if (name.toLowerCase() === OWNER_NAME.toLowerCase()) return true;
  return NAME_RE.test(name);
}

/**
 * True if `name` is a legal value to KEEP (load from storage / look up),
 * including legacy names that still contain a space. Used so we don't wipe a
 * spaced name before the player has had a chance to migrate it.
 */
export function isStorableName(name: string): boolean {
  if (!name) return false;
  if (name.length > MAX_NAME_LENGTH) return false;
  return STORED_NAME_RE.test(name);
}

export function hasSpace(name: string): boolean {
  return /\s/.test(name);
}

/** A stored name that must be migrated: it has a space and isn't the owner. */
export function needsRename(name: string): boolean {
  return hasSpace(name) && name.toLowerCase() !== OWNER_NAME.toLowerCase();
}
